export const headingClass = "mb-2 md:mb-[12px]";
export const headingClass1 = "mb-2 md:mb-[12px]";
export const headingClass2 = "mb-2 md:mb-5";
export const headingClass3 = "mb-4 md:mb-[32px]";
export const headingClassPg = "mb-2 md:mb-[12px] hidden md:block";

export const contentBodyMarginClass = "mb-1 md:mb-8 max-w-[500px]";
export const contentBodyMarginClass2 = "mb-1 md:mb-8 max-w-[550px]";
export const contentBodyMarginClass3 =
  "mb-1 md:mb-8 max-w-[98%]  md:max-w-[500px]";

export const imageClassName = "w-full md:pr-[38px]";
export const imageClassName1Pg = "w-[93%] md:pr-[18px]";
export const imageClassName2 = "w-full";
export const imageClassName3 = "w-full md:pr-[18px]";

export const contentClassName = "md:pl-[19px] mt-0 lg:pt-[60px] md:pt-[30px]";
export const contentClassName2 = "md:pl-[19px] mt-0  md:pt-[30px]";
export const contentClassName3 = "md:pl-[19px] mt-0";
export const contentClassNamePg = "mt-0 ";

export const terminalLine = "!text-tiny font-semibold md:!text-2sm";

export const alignStart = true;
export const mobileVisibleHeading = false;

export const errorFormFieldHighlight =
  "border-red-500 border text-2.5sm md:text-2sm rounded focus:ring-red-500 focus:border-red-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1";
export const validFormFieldHighlight =
  "border text-2.5sm md:text-2sm rounded focus:ring-green-500 focus:border-green-500 block w-full p-2.5 h-[48px] md:h-[46px] font-light mt-1";
export const selectFieldErrorHighlight =
  "border-red-500 border text-2.5sm md:text-2sm  rounded focus:ring-red-500 focus:border-red-500 block w-full mt-1";
export const selectFieldValidHighlight =
  "text-2.5sm md:text-2sm  rounded focus:ring-green-500 focus:border-green-500 block w-full mt-1";
